import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { AssessmentEditPageProvider } from "../context/AssessmentEditPageContext";
import { AssessmentEditSectionsOrganism } from "../organisms/AssessmentEditSectionsOrganism";
import { useAssessmentEdit } from "../context/AssessmentEditContext";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";
import { useMemo } from "react";
import { useWatch } from "react-hook-form";
import { AssessmentEditFormModel } from "../context/AssessmentEditContext";

export function AssessmentEditPagesOrganism() {
  const { hasEditingPermission, control, hasPages, appendPage } =
    useAssessmentEdit();

  const paginatedSections = useWatch<
    AssessmentEditFormModel,
    `paginatedSections`
  >({
    control,
    name: `paginatedSections`,
  });

  return (
    <View className="mb-4">
      <Text className="font-semibold text-lg mb-4">
        {hasPages ? "Pages" : "Sections"}
      </Text>
      <View className="gap-4">
        {paginatedSections.map((page, index) => (
          <View key={page.id} className="p-2 bg-gray-50 rounded">
            {hasPages ? (
              <Text className="font-semibold text-md mb-4">
                Page {index + 1}
              </Text>
            ) : null}
            <AssessmentEditPageProvider
              pageIndex={index}
              lastPage={index === paginatedSections.length - 1}
            >
              <AssessmentEditSectionsOrganism />
            </AssessmentEditPageProvider>
          </View>
        ))}
      </View>

      {hasEditingPermission && hasPages ? (
        <View className="flex items-center gap-4 py-4">
          <Button variant="outline" onPress={appendPage}>
            <ButtonText>Add page</ButtonText>
            <ButtonIcon as={AddIcon} />
          </Button>
        </View>
      ) : null}
    </View>
  );
}
